import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { TokenStorageService } from '../services/token-storage.service';

/**
 * Adjunta "Authorization: Bearer <token>" a las peticiones dirigidas a nuestra
 * propia API. No se agrega el token a peticiones hacia otros dominios (evita
 * filtrar el token a terceros por accidente).
 */
export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const tokenStorage = inject(TokenStorageService);
  const token = tokenStorage.getAccessToken();

  const isApiRequest = request.url.startsWith(environment.apiBaseUrl);

  if (token && isApiRequest) {
    request = request.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(request);
};
